const makeInitialState = () => {
  return {
    rfc: '',
    name: '',
    maternalName: '',
    paternalName: '',
    phone: '',
    email: '',
    personType: '',
    denomination: '',
    industry: '',
    existingRfc: false,
  };
};

export default makeInitialState;
